<template>
    <div class="uk-width-1-1 uk-margin-large-bottom" v-if="eventItem.title">
        <div class="uk-border-gradient">

            <div class="uk-card uk-card-primary uk-height-1-1">
                <div class="uk-card-background-image" v-if="eventItem.background.url">
                    <img loading="lazy" decoding="async" :src="eventItem.background.url">
                </div>
                <div class="uk-card-body uk-flex uk-flex-column uk-height-1-1">
                    <div class="dr-card-inner-blocks-wrap uk-flex uk-flex-column uk-height-1-1">
                        <div class="uk-flexgap is-layout-flex wp-block-group-is-layout-flex">
                            <div class="uk-width-expand">
                                <div v-if="eventItem.logo.url"
                                     class="uk-background-default uk-border-rounded-small uk-flex uk-flex-center uk-flex-middle uk-logo uk-padding-xsmall-left uk-padding-xsmall-right is-layout-constrained wp-block-group-is-layout-constrained">
                                    <figure class="wp-block-image size-large is-style-reset uk-logo-2xsmall">
                                        <img decoding="async" loading="lazy" :src="eventItem.logo.url">
                                    </figure>
                                </div>
                                <div class="uk-margin-xsmall-bottom uk-text-muted uk-text-overline" v-if="eventItem.label">
                                    {{ eventItem.label }}
                                </div>
                                <h5 class="uk-flex-1@s uk-margin-remove" :title="eventItem.title" v-if="eventItem.title">
                                    {{ eventItem.title }}
                                </h5>
                                <div class="uk-margin-remove-bottom uk-margin-xsmall-top"
                                     :title="eventItem.subtitle" v-if="eventItem.subtitle">{{ eventItem.subtitle }}
                                </div>
                            </div>
                            <a :href="eventItem.button.url" v-if="eventItem.button.url"
                               class="uk-button uk-button-default">
                                <span>{{ eventItem.button.title }}</span>
                                <span uk-icon="chevron-right" class="uk-icon"></span>
                            </a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
	name: "Event-featured-item",
	props: ['eventItem']
}
</script>

<style lang="scss">

</style>
